import { createContext } from 'react';

import { useAuthenticatedUser } from 'hooks/useAuthenticatedUser';

import { SystemUser } from 'common/types/system-users';

export const AuthenticatedUserContext = createContext<{
  isRoot: boolean;
  user: SystemUser;
  isAdmin: boolean;
  isLoaded: boolean;
  isLoginLoading: boolean;
  isAuthenticated: boolean;
  logout: () => Promise<void>;
  refetch: () => Promise<void>;
  hasRole: (role: string) => boolean;
  hasPermission: (permission: string) => boolean;
  login: ({
    username,
    password,
    tenantName,
    isRootLogin,
    isFortiCloudMode,
  }: {
    username: string;
    password: string;
    tenantName: string;
    isRootLogin: boolean;
    isFortiCloudMode: boolean;
  }) => Promise<void>;
}>({
  isRoot: false,
  isAdmin: false,
  user: undefined,
  isLoaded: false,
  login: undefined,
  logout: undefined,
  hasRole: undefined,
  refetch: undefined,
  isLoginLoading: false,
  isAuthenticated: false,
  hasPermission: undefined,
});

export const AuthenticatedUserProvider = ({ children }) => {
  const {
    user,
    login,
    logout,
    isRoot,
    refetch,
    isAdmin,
    hasRole,
    isLoaded,
    hasPermission,
    isLoginLoading,
    isAuthenticated,
  } = useAuthenticatedUser();

  return (
    <AuthenticatedUserContext.Provider
      value={{
        user,
        login,
        logout,
        isRoot,
        hasRole,
        refetch,
        isAdmin,
        isLoaded,
        hasPermission,
        isLoginLoading,
        isAuthenticated,
      }}
    >
      {children}
    </AuthenticatedUserContext.Provider>
  );
};
